module.exports = {"buildVersion":"2.17.14-220218356","release":"2.17.14","buildDateTime":"Fri Feb 18 2022 11:52"}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 2099
// module chunks = 23